module.exports = __webpack_public_path__ + "img/luyuanRecordBg.74ff3271.png";